// extracted by mini-css-extract-plugin
export default {"Icon":"sJmmAgq7wrEwBm1hwC4f"};